import _ from 'lodash';
import { useState, useEffect } from 'react';
import DownArrow from '@/assets/images/down-arrow.svg';
import GreenCheckmark from '@/assets/images/green-checkmark.svg';
import GreyCheckmark from '@/assets/images/grey-checkmark.svg';
import UpArrow from '@/assets/images/up-arrow.svg';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { selectReferences, setReferences } from '@/store/reducers/uploadSlice';
import {
  useFetchRelationshipTypesQuery,
  useFetchStatesQuery,
  useFetchEmergencyContactsReferencesQuery,
} from './references.services';
import ReferenceSection from './ReferenceSection';

const Reference1 = 'Emergency Contact 1';
const Reference2 = 'Emergency Contact 2';
const Reference3 = 'Emergency Contact 3';

interface ReferencesProp {
  startInteraction: (interaction: string) => void;
  trackClick: (eventType: string, parameters?: any) => void;
}

const References = ({startInteraction, trackClick}: ReferencesProp) => {
  const [expandEmergencyContact, setExpandEmergencyContact] = useState(false);
  const dispatch = useAppDispatch();

  const contactId = useAppSelector((state) => state.auth.contactId) || '';
  const references = useAppSelector(selectReferences);

  const { data: referenceList = {} } = useFetchEmergencyContactsReferencesQuery(contactId || '', {
    skip: !contactId,
    refetchOnMountOrArgChange: true,
  });
  const { data: stateList = [] } = useFetchStatesQuery();
  const { data: relationshipList = [] } = useFetchRelationshipTypesQuery();

  useEffect(() => {
    if (!_.isEmpty(referenceList)) {
      dispatch(setReferences(referenceList));
    }
  }, [referenceList, dispatch]);

  const allEmergencyContactsAdded =
    !_.isEmpty(references[Reference1]) && !_.isEmpty(references[Reference2]) && !_.isEmpty(references[Reference3]);

  const toggleEmergencyContact = () => {
    setExpandEmergencyContact((prev) => !prev);
    startInteraction('toggle_opened');
    trackClick(!expandEmergencyContact ? 'Toggle Opened' : 'Toggle Closed', {
      toggle_name: 'add_emergency_contacts',
      uploaded_count: references.length,
      total_required: '3',
    });
  };

  return (
    <>
      <div
        className="document-form__card--header"
        onClick={toggleEmergencyContact}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {allEmergencyContactsAdded ? (
            <img
              className="document-form__card--checkmark"
              src={GreenCheckmark}
              alt="Complete"
            />
          ) : (
            <img
              className="document-form__card--checkmark"
              src={GreyCheckmark}
              alt="Incomplete"
            />
          )}
          <span className="document-form__card--header-description">
            {allEmergencyContactsAdded ? 'Emergency Contacts' : 'Add Emergency Contacts'}
          </span>
        </div>
        {expandEmergencyContact ? (
          <img
            src={UpArrow}
            alt="Collapse"
          />
        ) : (
          <img
            src={DownArrow}
            alt="Expand"
          />
        )}
      </div>

      {expandEmergencyContact && (
        <div className="document-form__card--body">
          {[Reference1, Reference2, Reference3].map((refKey) => (
            <ReferenceSection
              key={refKey}
              heading={refKey}
              referenceData={!_.isEmpty(references[refKey]) ? references[refKey] : undefined}
              stateList={stateList}
              relationshipList={relationshipList}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default References;
